import { createSelector } from 'reselect';
import { lt } from 'semver';
import Constants from 'expo-constants';

import makeSelectMobile from '../Mobile/selectors';

import { initialState } from './reducer';

/**
 * Direct selector to the main state domain
 */
const selectMainDomain = (state) => state.main || initialState;

const selectShowNativeUpdateModal = () => createSelector(
  makeSelectMain('clientInfo'),
  makeSelectMobile('isNativeMobile'),
  makeSelectMain('isUpdateModalDismissed'),
  (clientInfo, isNativeMobile, isUpdateModalDismissed) => {
    if (isUpdateModalDismissed) return false;
    if (isNativeMobile) {
      try {
        const { storeVersion } = clientInfo;
        // Return if current app version is lesser than storeVersion
        return lt(Constants.expoConfig.version, storeVersion);
      } catch (e) {
        return false;
      }
    }
    return false;
  },
);

/**
 * Default selector used by Main
 */
const makeSelectMain = (prop) => createSelector(
  selectMainDomain,
  (mainState) => mainState[prop],
);

export default makeSelectMain;
export { selectShowNativeUpdateModal };
